export default __webpack_public_path__ + "static/99-92310b5beea4f464f222b5ce5c919d43.gif";